module.exports = __webpack_public_path__ + "static/media/eye.ace274c7.svg";